<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div class="px-3">
      <h3 class="mt-3 kl-title-md">
        {{ $getVisibleNames("mesh.taxonomy", true, "Taxonomías") }}
        <AlternativeNameButton
          :table_name="'mesh.taxonomy'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
        <!-- Taxonomías -->
      </h3>
      <div class="d-flex justify-content-between mx-2 px-2 align-items-center">
        <div>
          <ButtonMedium
            v-can="'mesh.add_cognitivelevel'"
            v-if="allows_crud && taxonomy && tab_index < 1"
            :tooltip_text="``"
            :click_button="() => $bvModal.show(`new-cognitive-level-modal`)"
            :custom_class="`my-2`"
            :text_button="`${$t('reusable.common.addTooltip', {
              entity: $getVisibleNames(
                'mesh.cognitivelevel',
                false,
                'Nivel Cognitivo'
              ),
            })}`"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- <button
            v-can="'mesh.add_cognitivelevel'"
            v-if="allows_crud && taxonomy && tab_index < 1"
            class="btn btn-secondary btn-sm"
            @click="$bvModal.show(`new-cognitive-level-modal`)"
          >
            {{ $t("reusable.common.add") }}
            {{
              $getVisibleNames("mesh.cognitivelevel", false, "Nivel Cognitivo")
            }}
          </button> -->
        </div>
        <div class="w-50">
          <b-form-select
            v-model="selected_taxonomy_id"
            :options="taxonomies"
            text-field="name"
            value-field="id"
            size="sm"
          ></b-form-select>
        </div>
        <div>
          <ButtonSmall
            v-can="'mesh.add_taxonomy'"
            v-if="allows_crud"
            class="ml-1"
            :tooltip_text="`${$t('reusable.common.addTooltip', {
              entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
            })}`"
            :click_button="() => $bvModal.show('modal-new-taxonomy')"
            :icon="'plus'"
          ></ButtonSmall>
          <!-- <button-add
            v-can="'mesh.add_taxonomy'"
            v-if="allows_crud"
            @click="$bvModal.show('modal-new-taxonomy')"
            :title="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
              })
            "
          ></button-add> -->
          <ButtonSmall
            v-can="'mesh.change_taxonomy'"
            v-if="allows_crud && taxonomy"
            class="ml-1"
            :tooltip_text="`${$t('reusable.common.editTooltip', {
              entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
            })}`"
            :click_button="() => $bvModal.show('modal-edit-taxonomy')"
            :icon="'square'"
          ></ButtonSmall>
          <!-- <button-edit
            v-can="'mesh.change_taxonomy'"
            v-if="allows_crud && taxonomy"
            @click="$bvModal.show('modal-edit-taxonomy')"
            :title="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
              })
            "
          ></button-edit> -->
          <ButtonSmall
            v-can="'mesh.delete_taxonomy'"
            v-if="allows_crud && taxonomy"
            class=""
            :tooltip_text="`${$t('reusable.common.deleteTooltip', {
              entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
            })}`"
            :click_button="deleteTaxonomy"
            :icon="'trash'"
          ></ButtonSmall>
          <!-- <button-delete
            v-can="'mesh.delete_taxonomy'"
            v-if="allows_crud && taxonomy"
            @click="deleteTaxonomy"
            :title="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
              })
            "
          ></button-delete> -->
        </div>
      </div>
      <b-tabs class="mt-4" v-model="tab_index">
        <b-tab :title="taxonomy ? taxonomy.name : ''">
          <div
            v-if="taxonomy && taxonomy.active"
            class="pb-1 default-taxonomy-message"
          >
            {{
              $t("toolbar.taxonomy.defaultTaxonomyMessage", {
                taxonomy: $getVisibleNames("mesh.taxonomy", false, "Taxonomía"),
              })
            }}
          </div>
          <hr />
          <div class="row taxonomy-header mx-0">
            <div class="col">
              {{ $t("toolbar.taxonomy.level") }}
            </div>
            <div class="col">
              {{ $t("reusable.common.description") }}
            </div>
            <div class="col">
              {{ $t("toolbar.taxonomy.verbs") }}
            </div>
          </div>
          <div v-if="taxonomy">
            <draggable
              v-model="cognitiveLevelList"
              :disabled="!allows_crud"
              tag="div"
            >
              <CognitiveLevelRow
                v-for="cognitive_level in cognitiveLevelList"
                :key="cognitive_level.id"
                :CognitiveLevel="cognitive_level"
                :taxonomy_id="taxonomy.id"
                @deleted="slotDeleteCognitiveLevel"
                :allows_crud="allows_crud"
              ></CognitiveLevelRow>
            </draggable>
            <div v-if="taxonomy.cognitive_levels.length == 0">
              <p>{{ $t("toolbar.taxonomy.noCognitiveLevelsCreated") }}</p>
            </div>
          </div>

          <b-modal
            :id="`modal-new-taxonomy`"
            size="lg"
            :hide-footer="true"
            :title="
              $t('reusable.common.createModalTitle', {
                entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
              })
            "
          >
            <TaxonomyForm @created="slotCreatedTaxonomy"></TaxonomyForm>
          </b-modal>
          <b-modal
            v-if="taxonomy"
            :id="`modal-edit-taxonomy`"
            size="lg"
            :hide-footer="true"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames('mesh.taxonomy', false, 'Taxonomía'),
              })
            "
          >
            <TaxonomyForm
              :Taxonomy="taxonomy"
              @updated="slotUpdatedTaxonomy"
            ></TaxonomyForm>
          </b-modal>
          <b-modal
            v-if="taxonomy"
            :id="`new-cognitive-level-modal`"
            :hide-footer="true"
            size="lg"
            :title="$t('toolbar.taxonomy.createCognitiveLevel')"
          >
            <CognitiveLevelForm
              :taxonomy_id="selected_taxonomy_id"
              :order="order"
              @created="slotCreatedCognitiveLevel"
            ></CognitiveLevelForm>
          </b-modal>
        </b-tab>
        <b-tab :title="$t('toolbar.taxonomy.verbsWithoutCognitiveLevel')">
          <h5 class="my-3 verbs-title mb-5">
            {{ $t("toolbar.taxonomy.verbsWithoutCognitiveLevel") }}
          </h5>
          <div class="verbs-container mt-3">
            <template v-if="orphanedActionsFilter.length > 0">
              <div
                v-for="custom_verb in orphanedActionsFilter"
                :key="custom_verb.id"
              >
                <div v-if="custom_verb.action != null" class="verbs-div mt-1">
                  {{ custom_verb ? custom_verb.action : "" }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="empty-orphaned-verbs">
                {{ $t("toolbar.taxonomy.noVerbsToShow") }}
              </div>
            </template>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

export default {
  name: "TaxonomyView",
  components: {
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    CognitiveLevelRow: () =>
      import(
        "@/components/mesh/MethodologicalResources/Taxonomy/CognitiveLevelRow"
      ),
    CognitiveLevelForm: () =>
      import(
        "@/components/mesh/MethodologicalResources/Taxonomy/CognitiveLevelForm"
      ),
    draggable,
    TaxonomyForm: () => import("./TaxonomyForm"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      selected_taxonomy_id: 1,
      tab_index: 0,
      orphaned_actions: [],
    };
  },
  computed: {
    ...mapGetters({
      taxonomy_active: names.TAXONOMY,
      taxonomies: names.TAXONOMIES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.taxonomy", true, "Taxonomías"),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_taxonomy");
      if (has_permission) return has_permission;
      else return false;
    },
    orphanedActionsFilter() {
      let actions_taxonomy = [];
      if (this.taxonomy_active) {
        this.taxonomy.cognitive_levels.forEach((cognitive_level) => {
          actions_taxonomy = actions_taxonomy.concat(
            cognitive_level.verbs.map((x) => x.name.toLowerCase())
          );
        });
      }
      actions_taxonomy = [...new Set(actions_taxonomy)];
      return this.orphaned_actions
        .filter(
          (verb) =>
            actions_taxonomy.filter((action_taxonomy) =>
              this.$equals(action_taxonomy, verb.action)
            ).length == 0
        )
        .sort((a, b) => a.action.localeCompare(b.action));
    },
    taxonomy() {
      return this.taxonomies.find((x) => x.id == this.selected_taxonomy_id);
    },
    order() {
      let order = 0;
      if (this.taxonomy) {
        this.taxonomy.cognitive_levels.forEach((element) => {
          if (element.level > order) order = element.level;
        });
      }
      return order + 1;
    },
    cognitiveLevelList: {
      get() {
        if (!this.taxonomy) return [];
        let list = this.taxonomy.cognitive_levels;
        list.sort(function (a, b) {
          if (a.level < b.level) return -1;
          if (a.level > b.level) return 1;
          return 0;
        });
        return list;
      },
      set(list) {
        this.taxonomy.cognitive_levels = list;
        let order = 1;
        list.forEach((element) => {
          element.level = order;
          this.patchCognitiveLevel(element.id, { level: order });
          order++;
        });
      },
    },
  },
  methods: {
    fetchOrphanedVerbs() {
      this.$restful.Get(`/common/orphaned-actions/`).then((response) => {
        this.orphaned_actions = response.actions_without_verb;
      });
    },
    patchCognitiveLevel(id, item) {
      this.$restful.Patch(`/mesh/cognitive-level/${id}/`, item);
    },
    slotDeleteCognitiveLevel(taxonomy_id) {
      let index = this.taxonomy.cognitive_levels.findIndex(
        (x) => x.id == taxonomy_id
      );
      if (index != -1) this.taxonomy.cognitive_levels.splice(index, 1);
    },
    slotCreatedTaxonomy(taxonomy) {
      this.$bvModal.hide("modal-new-taxonomy");
      this.$store.dispatch(names.FETCH_TAXONOMY, taxonomy.id).then(() => {
        this.selected_taxonomy_id = taxonomy.id;
      });
    },
    slotUpdatedTaxonomy(taxonomy) {
      this.$bvModal.hide("modal-edit-taxonomy");
      this.selected_taxonomy_id = taxonomy.id;
    },
    deleteTaxonomy() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames("mesh.taxonomy", false, "Taxonomía"),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_TAXONOMY, this.taxonomy.id)
            .then(() => {
              if (this.taxonomies.length > 0) {
                this.selected_taxonomy_id = this.taxonomies[0].id;
                this.taxonomies.forEach((x) => {
                  if (x.active) this.selected_taxonomy_id = x.id;
                });
              }
            });
        }
      });
    },
    slotCreatedCognitiveLevel(cognitive_level) {
      this.taxonomy.cognitive_levels.push(cognitive_level);
      this.$bvModal.hide(`new-cognitive-level-modal`);
    },
  },
  watch: {
    taxonomies: function () {
      let taxonomy = this.taxonomies.find((x) => x.active);
      if (taxonomy) this.selected_taxonomy_id = taxonomy.id;
    },
  },
  mounted() {},
  created() {
    this.fetchOrphanedVerbs();
    if (this.taxonomies.length > 0)
      this.selected_taxonomy_id = this.taxonomies[0].id;
    this.$store.dispatch(names.FETCH_TAXONOMIES).then((response) => {
      response.forEach((x) => {
        if (x.active) this.selected_taxonomy_id = x.id;
      });
    });
  },
};
</script>

<style scoped>
button {
  margin: 1px 5px 1px 5px;
}
/* Encabezado de columnas (Nivel / Descripción / Verbos), alineado al
   estándar de headers styles_kl.css: fondo accent-medium + texto blanco. */
.taxonomy-header {
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  border-radius: var(--kl-radius-md);
  padding-top: var(--kl-space-2);
  padding-bottom: var(--kl-space-2);
  font-weight: var(--kl-fw-bold);
  letter-spacing: var(--kl-ls-wide);
}
.default-taxonomy-message {
  text-align: center;
  font-size: var(--kl-fs-caption);
  color: var(--kl-text-muted);
}
.verbs-title {
  border-bottom: 1px solid var(--kl-border-soft);
  margin-bottom: 0.1em !important;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  font-size: var(--kl-fs-title-sm);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-text-heading);
}
.verbs-container {
  width: 100%;
  min-height: fit-content;
  background: var(--kl-surface-muted);
  border: 1px solid var(--kl-table-border);
  border-radius: var(--kl-radius-lg);
  padding: 1em;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
/* Verbos sin nivel cognitivo: no tienen color propio → chip neutro
   (formato único de chips del estándar). */
.verbs-div {
  background-color: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  max-width: fit-content;
  border-radius: var(--kl-chip-radius);
  margin: 0.1em 0.15em;
  padding: var(--kl-chip-padding);
  flex-grow: 1;
  font-size: var(--kl-chip-fs);
  text-align: center;
  font-weight: var(--kl-chip-fw);
}
.empty-orphaned-verbs {
  color: var(--kl-text-muted);
}
</style>